import React from 'react';
import {useTranslate} from 'react-redux-multilingual';
import {TbBrandTelegram, TbBrandWhatsapp, TbCalendarEvent, TbPhone} from 'react-icons/tb';
import contacts, {telegramHref, whatsappHref} from '../../../../constants/contacts';

// Thumb-reach contact bar, phones only (< 768px).
function QuickContact({onScheduleVisit}) {
    const t = useTranslate();
    return (
        <div className="cpr-dock" role="region" aria-label={t('contact')}>
            <a className="cpr-dock__item" href={contacts.phone.href}>
                <TbPhone aria-hidden="true"/><span>{t('call')}</span>
            </a>
            {whatsappHref &&
                <a className="cpr-dock__item" href={whatsappHref} target="_blank" rel="noopener noreferrer">
                    <TbBrandWhatsapp aria-hidden="true"/><span>{t('whatsapp')}</span>
                </a>
            }
            {telegramHref &&
                <a className="cpr-dock__item" href={telegramHref} target="_blank" rel="noopener noreferrer">
                    <TbBrandTelegram aria-hidden="true"/><span>{t('telegram')}</span>
                </a>
            }
            <button type="button" className="cpr-dock__item cpr-dock__item--primary" onClick={onScheduleVisit}>
                <TbCalendarEvent aria-hidden="true"/><span>{t('schedule_a_visit')}</span>
            </button>
        </div>
    );
}

export default QuickContact;
